import type {ColumnSizingState, OnChangeFn} from '@tanstack/react-table'
import {useState} from 'react'

import {useViews} from '../../use-views'

/**
 * Custom hook to hoist columnSizing state for TanStack Table,
 * so we can scope it to the current view.
 *
 * We prefer this approach over the native table.resetColumnSizing() because
 * it avoids race conditions.
 */
export const useColumnSizing = () => {
  const {currentView} = useViews()
  const viewNumber = currentView?.number ?? 0
  const [columnSizing, setColumnSizing] = useState<Record<number, ColumnSizingState>>({[viewNumber]: {}})
  const currentSizing = columnSizing[viewNumber] ?? {}

  // Pass through the default updater from TanStack Table without change except
  // to scope by viewNumber.
  // TanStack Table falls back to `size` property on column definitions when state is empty.
  const onColumnSizingChange: OnChangeFn<ColumnSizingState> = updater => {
    const newState = typeof updater === 'function' ? updater(currentSizing) : updater
    setColumnSizing({...columnSizing, [viewNumber]: newState})
  }
  return {columnSizing: currentSizing, onColumnSizingChange}
}
